//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.BaseIdSymbolBuilder.js";
import "../Annotations/Annotations.AnnotationPlacement.js";
let d=[[[0,"ForeshorteningSymbol",0,"Annotations.ForeshorteningSymbolBuilder",0],[0,"Type",1,1]],[],[]];
SPLM.Annotations.IdSymbolBuilder = class extends SPLM.Annotations.BaseIdSymbolBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.IdSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.IdSymbolBuilder.SymbolTypes = Object.freeze({
    "Circle" : "Circle", "DividedCircle" : "DividedCircle", "Triangle" : "Triangle", "TriangleUp" : "TriangleUp", "Square" : "Square", "DividedSquare" : "DividedSquare", "Hexagon" : "Hexagon", "DividedHexagon" : "DividedHexagon", "QuadrantCircle" : "QuadrantCircle", "RoundedBox" : "RoundedBox", "Underline" : "Underline", "Nosymbol" : "Nosymbol"});

export default SPLM;